module.exports = __webpack_public_path__ + "images/category_lp/electric_tool/assessment_achievements/2_d16d680a65e30be9e92630e4dceb7f96.jpg";